import type { Role } from '@/entities/user';

export const inventoryAccessRoles = [
  'admin',
  'warehouse_manager',
] as const satisfies readonly Role[];
